module.exports = __webpack_public_path__ + "img/slider-next--dark.55ccd30e.svg";